import pick from 'lodash/pick';

import { SET_EDITED_BASKET, CLEAR_EDITED_BASKET, UNDO_BASKET_EDITS } from 'actions/basketEdits';
import {
  ADD_BASKET_RESPONSE,
  UPDATE_BASKET_RESPONSE,
  GET_RECEIPT_RESPONSE,
  GET_RECEIPT_ERROR,
  UNDONATE_BASKET_RESPONSE,
  DONATE_BASKET_RESPONSE,
} from 'actions/baskets';

const initialState = {
  isReceiptLoading: true,
  behavioralDiscounts: [],
  behavioralDiscountLineItems: [],
  belowLowPricedShippingMin: false,
  belowMinimum: false,
  belowUpchargeableThreshold: false,
  creditDollars: 0,
  creditFormatted: '$0.00',
  displayLowShipping: false,
  displayOrderMealsAndSave: false,
  displaySavingPerMeal: false,
  mealCountForNextLowestPriceTier: 0,
  mealPricing: [],
  orderSummaryMeals: [],
  priceModifierCents: 0,
  recurringDiscountCents: 0,
  recurringDiscountPercent: 0,
  recurringDiscountFormatted: '$0.00',
  recurringDiscountName: '',
  salesTaxFormatted: '$0.00',
  salesTaxCents: 0,
  shippingDollars: 0,
  shippingFormatted: '',
  shippingPriceDiffAmountCentsFormatted: '$0',
  subtotalDollars: 0,
  subtotalFormatted: '$0.00',
  subtotalForCutoffsCents: 0,
  totalDollars: 0,
  totalFormatted: '$0.00',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RECEIPT_ERROR:
      return {
        ...state,
        isReceiptLoading: false,
      };
    case ADD_BASKET_RESPONSE:
    case UNDONATE_BASKET_RESPONSE:
    case UPDATE_BASKET_RESPONSE:
    case DONATE_BASKET_RESPONSE:
      return {
        ...state,
        ...pick(action.response.weeklyBasket, Object.keys(initialState)),
      };
    case GET_RECEIPT_RESPONSE:
      return {
        ...state,
        ...pick(action.response, Object.keys(initialState)),
        isReceiptLoading: false,
      };
    case UNDO_BASKET_EDITS:
    case SET_EDITED_BASKET:
      return {
        ...state,
        ...pick(action.basket, Object.keys(initialState)),
      };
    case CLEAR_EDITED_BASKET:
      return initialState;
    default:
      return state;
  }
};
